import Storage from 'good-storage'
import store from '@/store/index'

export const formatDate = function (v, format) {
  if (!v) return ""
  var d = v
  if (typeof v === 'string') {
    if (v.indexOf("/Date(") > -1) {
      d = new Date(parseInt(v.replace("/Date(", "").replace(")/", ""), 10))
    } else {
      d = new Date(Date.parse(v.replace(/-/g, "/").replace("T", " ").split(".")[0])) // .split(".")[0] 用来处理出现毫秒的情况，截取掉.xxx，否则会出错
    }
  }

  var o = {
    "M+": d.getMonth() + 1, // month
    "d+": d.getDate(), // day
    "h+": d.getHours(), // hour
    "m+": d.getMinutes(), // minute
    "s+": d.getSeconds(), // second
    "q+": Math.floor((d.getMonth() + 3) / 3), // quarter
    "S": d.getMilliseconds() // millisecond
  }

  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (d.getFullYear() + "").substr(4 - RegExp.$1.length))
  }

  for (var k in o) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length))
    }
  }
  return format
}

export const getCurDate = function (action) {
  let date = new Date();
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  month = month < 10 ? ("0" + month) : month;
  let day = date.getDate();
  day = day < 10 ? ("0" + day) : day;
  let cur_time = year + "-" + month + "-" + day;
  let cur_month = year + "-" + month;
  if (action == "time") { //时分秒
    let hour = date.getHours();
    let minutes = date.getMinutes();
    let seconds = date.getSeconds();
    hour = hour < 10 ? ("0" + hour) : hour;
    minutes = minutes < 10 ? ("0" + minutes) : minutes;
    seconds = seconds < 10 ? ("0" + seconds) : seconds;
    let time = hour + ":" + minutes + ":" + seconds;
    cur_time = cur_time + " " + time;
  }
  return cur_time;
}

// 判断浏览器
export function isPC() {
  if (/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)) {
    return false
  } else {
    return true
  }
}
// 判断微信环境
export function isWX() {
  var ua = navigator.userAgent.toLowerCase()
  var isWeixin = ua.indexOf('micromessenger') !== -1
  if (isWeixin) {
    return true
  } else {
    return false
  }
}
// 判断安卓环境
export function isAndroid() {
  let ua = navigator.userAgent.toLowerCase();
  if (ua && ua.indexOf("android") > -1) {
    return true;
  } else {
    return false;
  }
}

// 提取url参数
export function getQueryString(href, key) {
  var reg = new RegExp('[?&]' + key + '=([^&]*)', 'g')
  var match = (href || window.location.search).match(reg)
  if (!match) return
  if (match.length === 1) return decodeURIComponent(match[0].replace(reg, '$1'))
  match = match.map(function (item) {
    return decodeURIComponent(item.replace(reg, '$1'))
  })
  return match
}

export function replaceQueryString(paramName, replaceWith) {
  let oUrl = window.location.href.toString()
  let re = new RegExp('(' + 'code' + '=)([^&]*)', 'gi')
  let nUrl = oUrl.replace(re, paramName + '=' + replaceWith)
  return nUrl
}

// 获得对象数组中出现次数最多的前n项

export function getTheMostNitemInArray(arr, compareProject, n) { // compareProject为根据什么来计算出现次数
  arr = JSON.parse(JSON.stringify(arr))
  var count = 1
  var yuansu = [] // 存放数组array的不重复的元素
  var sum = [] // 存放数组array中每个不同元素的出现的次数
  for (var i = 0; i < arr.length; i++) {
    for (var j = i + 1; j < arr.length; j++) {
      if (arr[i][compareProject] === arr[j][compareProject]) {
        count++ // 用来计算与当前这个元素相同的个数
        arr.splice(j, 1) // 每找到一个相同的元素，就要把它移除掉，
        j--
      }
    }
    yuansu[i] = arr[i] // 将当前的元素存入到yuansu数组中
    sum[i] = count // 并且将有多少个当前这样的元素的个数存入sum数组中
    count = 1 // 再将count重新赋值，进入下一个元素的判断
  }
  var newArr = []
  for (var m = 0; m < yuansu.length; m++) { // 将元素和对应的出现次数组成一个对象放入数组
    var obj = {}
    obj.name = yuansu[m]
    obj.value = sum[m]
    newArr.push(obj)
  }
  newArr.sort(function (x, y) { // 根据出现次数进行排序
    return y.value - x.value
  })
  var nMostSearch = [] // 出现次数最多的n个项目
  newArr.slice(0, n).forEach(function (item) {
    nMostSearch.push(item.name)
  })
  return nMostSearch
}

export function differenceSet(arr1, arr2, key) { // 求两个对象数组的差集(arr1 - arr2)
  let arr = []
  arr1.forEach(element => {
    let bol = false
    arr2.forEach(ele => {
      if (element[key] === ele[key]) {
        bol = true
      }
    })
    if (!bol) {
      arr.push(element)
      bol = false
    }
  })
  return arr
}

export function dateFormat(time, format) {
  var t = new Date(time)
  var tf = function (i) {
    return (i < 10 ? '0' : '') + i
  }
  return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function (a) {
    switch (a) {
      case 'yyyy':
        return tf(t.getFullYear())
      case 'MM':
        return tf(t.getMonth() + 1)
      case 'mm':
        return tf(t.getMinutes())
      case 'dd':
        return tf(t.getDate())
      case 'HH':
        return tf(t.getHours())
      case 'ss':
        return tf(t.getSeconds())
    }
  })
}

// 防抖动
export function debounce(func, delay) {
  let timer
  delay = delay ? delay : 300
  return function (...args) {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      func.apply(this, args)
    }, delay)
  }
}

// cookie操作
export let cookie = {
  //name是cookie中的名，value是对应的值，days是多久过期（单位为天）,path:设置cookie作用域
  setCookie: function (name, value, days) {
    let iTime = arguments[2] ? arguments[2] : 30; //此 cookie 将被保存 30 天
    let oDate = new Date();
    oDate.setTime(oDate.getTime() + iTime * 24 * 3600 * 1000);
    document.cookie = name + "=" + value + ";path=/;expires=" + oDate.toGMTString();
  },
  getCookie: function (name) {
    let arr = document.cookie.split("; ");
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].split("=")[0] == name) {
        return arr[i].split("=")[1];
      }
    }
    //未找到对应的cookie则返回空字符串
    return '';
  },
  removeCookie: function (name) {
    if (name.indexOf(",") == -1) {
      this.setCookie(name, 1, -1);
    } else {
      let arr = name.split(",");
      for (let i = 0; i < arr.length; i++) {
        this.setCookie(arr[i], 1, -1);
      }
    }
  }
};

// 高亮搜索结果
export function highlight(text, words, tag) {
  // 默认的标签，如果没有指定，使用span
  tag = tag || 'span';
  let i, len = words.length,
    re;
  //匹配每一个特殊字符 ，进行转义
  let specialStr = ["*", ".", "?", "+", "$", "^", "[", "]", "{", "}", "|", "\\", "(", ")", "/", "%"];

  specialStr.forEach(ele => {
    if (words.indexOf(ele) != -1) {
      words = words.replace(new RegExp("\\" + ele, 'g'), "\\" + ele);
    }
  })

  //匹配整个关键词
  re = new RegExp(words, 'g');

  if (re.test(text)) {
    text = text.replace(re, '<' + tag + ' class="highlight">$&</' + tag + '>');
  }
  return text;
}

//判断是否是空对象
export function isEmptyObj(obj) {
  for (let n in obj) {
    return false;
  }
  return true;
}

// 小数保留操作
export let digitalOperation = {
  mathFloor: function (target) {
    return Math.floor(target * 100) / 100;
  },
  mathFloat: function (target) {
    return Math.round(target * 100) / 100;
  },
  mathSixFloat: function (target) {
    return Math.round(target * 1000000) / 1000000;
  },
  mathInt: function (target) {
    return Math.round(target);
  },
}

export function isPhone(phone) {
  if (!(/^1(3|4|5|7|8)\d{9}$/.test(phone))) {
    return false;
  } else {
    return true;
  }
}

//生成时间戳
export function timestamp() {
  return new Date().getTime();
}

// 深拷贝
export function deepClone(obj) {
  let new_obj = {};
  for (let key in obj) {
    new_obj[key] = obj[key];
  }
  return new_obj;
}


// 根据后台设置进行金钱精度转换
export function moneySwitch(money, precision, precision_type) {
  var result = 0;
  //先进行一个千分位的四舍五入，保证3.0999这种情况在保留一位小数的时候能是对的
  var money = parseFloat(money).toFixed(3);
  try {
    var int_part = money.split(".")[0], //小数点前的整数
      point_num = money.split(".")[1], //取小数点后面的数
      precision_num = point_num[3 - precision];
    if ((precision_type == 1 && precision_num > 4) || (precision_type == 3 && precision_num > 0)) { //五入&进1的情况
      if (precision == 1) {
        point_num = parseInt(point_num) + 10 + "";
        if (point_num.length > 3) { //说明往整数位进1
          int_part = parseInt(int_part) + 1 + "";
          point_num = point_num[1] + point_num[2];
        } else {
          point_num = point_num[0] + point_num[1];
        }
      } else if (precision == 2) {
        point_num = parseInt(point_num) + 100 + "";
        if (point_num.length > 3) { //说明往整数位进1
          int_part = parseInt(int_part) + 1 + "";
          point_num = point_num[1];
        } else {
          point_num = point_num[0];
        }
      } else if (precision == 3) {
        int_part = parseInt(int_part) + 1 + "";
        point_num = 0;
      }
    } else { //去掉尾数的情况和四舍的情况以及不进1的情况
      if (precision == 1) {
        point_num = point_num[0] + point_num[1];
      } else if (precision == 2) {
        point_num = point_num[0];
      } else if (precision == 3) {
        point_num = 0;
      }
    }
    result = parseFloat(int_part + "." + point_num);
  } catch (e) {
    return parseFloat(money).toFixed(2);
  }
  return result;
}




// localstorage日志记录
export function addLog(operate_obj){
    var record_data = {
        "front_end_pay_id":$orderBox.attr("data-ordercode"),
        "local_time":new Date().Format("yyyy-MM-dd HH:mm:ss"),
        "opearte_obj":operate_obj,
        "cashier_name":CASHIER_INFO.name,
        "shop_name":SHOP_INFO.name
    };
    if(!$(".pop-stored-value").hasClass("hide")){
        record_data.front_end_pay_id = $(".pop-stored-value").attr("data-ordercode");
    }
    var record_id = new Date().getTime();
    if(window.localStorage){
        var storage = window.localStorage,cashierLog={};
        if(storage.getItem("cashierLog")){
            cashierLog = JSON.parse(storage.getItem("cashierLog"));
        }
        cashierLog[record_id] = record_data;
        storage.setItem("cashierLog",JSON.stringify(cashierLog));
    }
}
export function getLog(){
  return Storage.get("cashierLog");
}
export function removeLog(){
    if(window.localStorage){
        var storage = window.localStorage;
        storage.removeItem("cashierLog");
    }
}

// 获取格式化时间
export function getFormatTime() {
  let date = new Date();
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  month = month < 10 ? '0' + month : '' + month;
  day = day < 10 ? '0' + day : '' + day;

  return year + '-' + month + '-' + day;
}
// 获取格式化时间-明天
export function getTommrow() {
  var date = new Date();
  var day = parseInt(date.getDate());
  date.setDate(day+1);
  var year = date.getFullYear();
  var month = date.getMonth()+1;
  day = date.getDate();
  day = day<10?("0"+day):day;
  month = month<10?("0"+month):month;
  var cur_time = year+"-"+month+"-"+day;
  return cur_time;
}

//获取格式化时间-今天
export function getToday(){
  var date = new Date();
  var day = parseInt(date.getDate());
  var year = date.getFullYear();
  var month = date.getMonth()+1;
  day = date.getDate();
  day = day<10?("0"+day):day;
  month = month<10?("0"+month):month;
  var cur_time = year+"-"+month+"-"+day;
  return cur_time;
}

// 根据当前的data_type，链接是否添加data_type
export function getZhaExportUrl(data_type, url) {
  if(data_type === 1){
    let newUrl="";
    if(url.match("[\?]")){
        newUrl= url + "&" + "data_type=1";
    }else{
        newUrl= url + "?" + "data_type=1";
    }
    return newUrl;
  }else{
    return url;
  }
}

/**
 * 日期选择器特有选项
 * @param {*} dateType 0--自然日（明天之后日期被禁用）；1--扎帐日（今天之后日期被禁用）
 * @param {*} dayLimit 日期范围
 * @param {*} shortcuts 日期快捷选项
 * @param {*} type 日期选择器类型，默认daterange
 */
export function eleDatePickerInit(options = {}) {
  let { dayLimit, shortcuts, type } = options
  let dayNum = dayLimit || 91
  let shortcutsArry = shortcuts || [7, 30, 90]
  let pickerType = type || 'daterange'
  let dateType = store.getters.dataType
  let _minTime = null
  let _maxTime = null
  let pickerOptions = {
    /**
     * 选中日期后会执行的回调
     * 只有当 daterange 或 datetimerange 才生效
     * @param {*} time 
     */
    onPick(time){
      const { maxDate, minDate } = time
      if (!maxDate) {  // 只选择了一个时间
        const timeRange = dayNum*24*60*60*1000
        _minTime = minDate.getTime() - timeRange // 最小时间
        _maxTime = minDate.getTime() + timeRange // 最大时间
      } else {
        _minTime = _maxTime = null
      }
    },
    /**
     * 日期组件初始化切换、onpick触发
     * @param {*} time 
     */
    disabledDate(time) {
      let boolRanger = false  //日期范围判定
      let boolDateType = false //自然日、扎帐日判定
      if(_maxTime && _minTime){
        boolRanger = time.getTime() < _minTime || time.getTime() > _maxTime
      }
      if(dateType == 0){
        boolDateType = time.getTime() - 24*60*60*1000> Date.now() - 8.64e7
      }else{
        boolDateType = time.getTime() - 48*60*60*1000> Date.now() - 8.64e7
      }
      return boolRanger || boolDateType
    } 
  }
  if(pickerType=='daterange'){
    pickerOptions = { ...pickerOptions, shortcuts: setShortcuts(shortcutsArry) }
  }
  return pickerOptions;
}

//为datepicker设置快捷选项
function setShortcuts(shortcutsArry){
  const chnNumChar = {
    0:'零',1:'一',2:'二',3:'三',4:'四',5:'五',6:'六',7:'七',8:'八',9:'九'
  }
  let shortcuts = []
  shortcutsArry.forEach((day) => {
    let obj = {}
    let text,num = day
    if(Object.prototype.toString.call(day) == "[object Object]"){
      text = day.text
      num = day.value
    }else{
      if(day>=30&&day%30==0){
        text = '最近'+chnNumChar[Math.floor(day/30)]+'个月'
      }else if(day>=7&&day%7==0){
        text = '最近'+chnNumChar[Math.floor(day/7)]+'周'
      }else{
        text = '最近'+chnNumChar[day]+'天'
      }
    }
    obj.text = text
    obj.onClick = (picker) => {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * num)
      picker.$emit('pick', [start, end])
    }
    shortcuts.push(obj)
  })
  return shortcuts
}

// 日期选择器的时间初始化
// param type 0 单个日期选择器 1 区间选择
export function initPickerDataTime(type) { 
  let dateType = store.getters.dataType
  let date = new Date();
  let year = date.getFullYear();
  let month = date.getMonth()+1;
  let curTime,dateTime;
  if(dateType==1){
    curTime = getTommrow()
  }else{
    curTime = getToday()
  }
  if(type){
    let sTime = year+'-'+month+'-'+'01';
    dateTime = [sTime, curTime];
  }else{
    dateTime = curTime;
  }
  return dateTime;
}

export function mathFloat(target){
  return Math.round(target*100)/100;
}

// 深度克隆
function cloneObjByDeep(obj) {
  var new_obj = {};
  for (var key in obj) {
      new_obj[key] = obj[key];
  }
  return new_obj;
}

export function inputLimit(reg) {
  return function(that, key) {
      // debugger
      const fn = Object.prototype.toString.call(that[key]) === "[object Number]" ? Number : String
      let value = that[key].toString()
      do {
          if (!reg.test(value)) {
              if (value.length > 0) {
                  value = value.substr(0, value.length - 1)
                  that[key] = fn(value)
              } else {
                  return
              }
          }
      } while (!reg.test(value))
  }
}

// // 指定普通输入，配合max实现长度限制
// export function inputLimitNormal() {
//   return inputLimit(/^1[0-9]{0,10}$/)
// }

// // 电话号码的正则
// export function inputLimitPhone() {
//   return inputLimit(/^1[0-9]{0,10}$/)
// }

// // 银行卡号的正则
// export function inputLimitBankCard() {
//   return inputLimit(/^[0-9]{1,15}$/)
// }()
